//cw: list based on IANA zonenow from 2025-03-22
const simplifiedList = [
    // Americas
    { id: 'Pacific/Honolulu', name: 'Hawaii (HST)' },
    { id: 'America/Anchorage', name: 'Alaska (AKST/AKDT)' },
    { id: 'America/Los_Angeles', name: 'Pacific Time (PST/PDT)' },
    { id: 'America/Denver', name: 'Mountain Time (MST/MDT)' },
    { id: 'America/Chicago', name: 'Central Time (CST/CDT)' },
    { id: 'America/New_York', name: 'Eastern Time (EST/EDT)' }//,
    // { id: 'America/Halifax', name: 'Atlantic Time (AST/ADT)' },
    // { id: 'America/St_Johns', name: 'Newfoundland (NST/NDT)' },
    // { id: 'America/Sao_Paulo', name: 'Brazil (BRT)' },
    // { id: 'America/Buenos_Aires', name: 'Argentina (ART)' },
    // { id: 'America/Santiago', name: 'Chile (CLT/CLST)' },
    
    // // Europe & Africa
    // { id: 'Europe/London', name: 'London (GMT/BST)' },
    // { id: 'Europe/Paris', name: 'Paris/Berlin (CET/CEST)' },
    // { id: 'Europe/Athens', name: 'Athens (EET/EEST)' },
    // { id: 'Europe/Moscow', name: 'Moscow (MSK)' },
    // { id: 'Africa/Johannesburg', name: 'South Africa (SAST)' },
    // { id: 'Africa/Cairo', name: 'Cairo (EET)' },
    
    // // Asia
    // { id: 'Asia/Dubai', name: 'Dubai/Abu Dhabi (GST)' },
    // { id: 'Asia/Karachi', name: 'Pakistan (PKT)' },
    // { id: 'Asia/Kolkata', name: 'India/Sri Lanka (IST)' },
    // { id: 'Asia/Dhaka', name: 'Bangladesh (BST)' },
    // { id: 'Asia/Bangkok', name: 'Bangkok/Vietnam (ICT)' },
    // { id: 'Asia/Singapore', name: 'Singapore/Malaysia (SGT)' },
    // { id: 'Asia/Shanghai', name: 'China/Beijing (CST)' },
    // { id: 'Asia/Hong_Kong', name: 'Hong Kong (HKT)' },
    // { id: 'Asia/Tokyo', name: 'Japan (JST)' },
    // { id: 'Asia/Seoul', name: 'Korea (KST)' },
    
    // // Oceania
    // { id: 'Australia/Perth', name: 'Perth (AWST)' },
    // { id: 'Australia/Adelaide', name: 'Adelaide (ACST/ACDT)' },
    // { id: 'Australia/Sydney', name: 'Sydney/Melbourne (AEDT/AEST)' },
    // { id: 'Pacific/Auckland', name: 'New Zealand (NZDT/NZST)' },
    // { id: 'Pacific/Fiji', name: 'Fiji (FJT)' }
];

const timezoneModel = { list: simplifiedList }
export default timezoneModel